(function () {
  'use strict';

  var CFG = window.FirmeCartConfig || {};
  var INSURANCE_ID = String(CFG.insuranceVariantId || '');
  var GIFT_ID = String(CFG.giftVariantId || '');
  var GIFT_MIN = Number(CFG.giftMinSubtotal || 0);
  var ROLE_PROP = '_firme_role'; // line-item property that marks lines THIS script added

  var root = document.getElementById('FirmeCart');
  if (!root) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function roleOf(item) {
    return (item && item.properties && item.properties[ROLE_PROP]) || '';
  }
  function isManaged(item) { var r = roleOf(item); return r === 'gift' || r === 'insurance' || r === 'pack_gift'; }
  function isGiftRole(item) { var r = roleOf(item); return r === 'gift' || r === 'pack_gift'; }

  var els = {
    panel: root.querySelector('.firme-cart__panel'),
    scroll: root.querySelector('.firme-cart__scroll'),
    items: root.querySelector('[data-fc-items]'),
    empty: root.querySelector('[data-fc-empty]'),
    track: root.querySelector('[data-fc-upsell-track]'),
    upsellPrev: root.querySelector('[data-fc-upsell-prev]'),
    upsellNext: root.querySelector('[data-fc-upsell-next]'),
    saved: root.querySelector('[data-fc-saved]'),
    total: root.querySelector('[data-fc-total]'),
    insuranceToggle: root.querySelector('[data-fc-insurance-toggle]'),
    insurancePrice: root.querySelector('[data-fc-insurance-price]'),
    checkout: root.querySelector('[data-fc-checkout]')
  };

  var money = (function () {
    var currency = CFG.currency || 'CLP';
    var locale = CFG.locale || 'es-CL';
    if (locale.indexOf('-') === -1) locale = currency === 'CLP' ? 'es-CL' : locale;
    try {
      var fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency, maximumFractionDigits: 0 });
      return function (c) { return fmt.format(Math.round((c || 0) / 100)); };
    } catch (e) {
      return function (c) { return '$' + Math.round((c || 0) / 100).toLocaleString('es-CL'); };
    }
  })();

  var state = {
    cart: null,
    productCache: {},
    reconciling: false,
    giftGaveUp: false,
    lastItemsSig: null,
    bubbleThrottle: 0,
    insuranceBusy: false
  };

  /* ---------- insurance opt-in memory ---------- */
  function wantsInsurance() {
    if (!CFG.insuranceEnabled || !INSURANCE_ID) return false;
    var s = null;
    try { s = sessionStorage.getItem('firme_insurance'); } catch (e) {}
    if (s === '1') return true;
    if (s === '0') return false;
    return !!CFG.insuranceDefaultOn;
  }
  function setInsurancePref(on) { try { sessionStorage.setItem('firme_insurance', on ? '1' : '0'); } catch (e) {} }

  /* ---------- cart api (uses the real fetch, never the patched one) ---------- */
  var rawFetch = window.fetch.bind(window);
  function jpost(url, body) {
    return rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
  }
  function getCart() { return rawFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function addLine(body) { return jpost('/cart/add.js', body); }
  function changeLine(body) { return jpost('/cart/change.js', body); }

  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (state.productCache[handle] !== undefined) return Promise.resolve(state.productCache[handle]);
    return rawFetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { state.productCache[handle] = d || null; return d; })
      .catch(function () { state.productCache[handle] = null; return null; });
  }
  function compareAtFor(item) {
    var p = state.productCache[item.handle];
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === String(item.variant_id)) return p.variants[i].compare_at_price || null;
    }
    return null;
  }

  /* ---------- Shrine cart bubble (throttled, fire-and-forget) ---------- */
  function updateBubble() {
    var now = Date.now();
    if (now - state.bubbleThrottle < 1200) return;
    state.bubbleThrottle = now;
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    rawFetch('/?section_id=cart-icon-bubble')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.body;
        if (wrap) icon.innerHTML = wrap.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- open / close ---------- */
  var savedScrollY = 0;
  function scrollLock(on) {
    var b = document.body;
    if (on) {
      savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      b.style.position = 'fixed';
      b.style.top = -savedScrollY + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
    } else {
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      window.scrollTo(0, savedScrollY);
    }
  }
  function open() {
    if (isOpen()) return;
    scrollLock(true);
    root.setAttribute('aria-hidden', 'false');
  }
  function close() {
    if (!isOpen()) return;
    root.setAttribute('aria-hidden', 'true');
    scrollLock(false);
  }
  function isOpen() { return root.getAttribute('aria-hidden') === 'false'; }

  /* ---------- render ---------- */
  function lineHTML(item) {
    var isGift = isGiftRole(item);
    var free = isGift && item.final_price === 0;
    var compareAt = compareAtFor(item);
    var unitOrig = item.original_price;
    var unitFinal = item.final_price;

    var priceHTML;
    if (free) {
      priceHTML = '<span class="was">' + money(compareAt || unitOrig) + '</span>GRATIS';
    } else {
      var was = '';
      if (compareAt && compareAt > unitFinal) was = '<span class="was">' + money(compareAt) + '</span>';
      else if (unitOrig > unitFinal) was = '<span class="was">' + money(unitOrig) + '</span>';
      priceHTML = was + money(unitFinal);
    }

    var img = sized(item.image, 128);
    var title = esc((item.product_title || item.title || '').toUpperCase());
    var vLabel = (item.variant_title && item.variant_title !== 'Default Title') ? esc(item.variant_title) : '';
    var lockQty = free; // only the free gift has no qty controls
    var qtyBlock = lockQty ? '' :
      '<div class="firme-cart__qty">' +
        '<button type="button" data-fc-dec data-key="' + esc(item.key) + '" aria-label="Restar">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-fc-inc data-key="' + esc(item.key) + '" aria-label="Sumar">+</button>' +
      '</div>';

    return '' +
      '<div class="firme-cart__item" data-key="' + esc(item.key) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<img alt="">') +
        '<div class="firme-cart__item-info">' +
          '<div class="firme-cart__item-title">' + (free ? '<span class="free">(GRATIS)</span> ' : '') + title + '</div>' +
          (vLabel ? '<div class="firme-cart__item-variant">' + vLabel + '</div>' : '') +
          '<div class="firme-cart__item-price">' + priceHTML + '</div>' +
          qtyBlock +
        '</div>' +
        '<button type="button" class="firme-cart__remove" data-fc-remove data-key="' + esc(item.key) + '" aria-label="Eliminar">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
            '<polyline points="3 6 5 6 21 6"></polyline>' +
            '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>' +
            '<path d="M10 11v6"></path><path d="M14 11v6"></path>' +
            '<path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>' +
          '</svg>' +
        '</button>' +
      '</div>';
  }

  function render() {
    var cart = state.cart;
    if (!cart) return;

    // visible = everything except the insurance line (it's represented by the toggle)
    var visible = cart.items.filter(function (it) { return roleOf(it) !== 'insurance'; });
    // regalos al final
    visible.sort(function (a, b) {
      return (isGiftRole(a) ? 1 : 0) - (isGiftRole(b) ? 1 : 0);
    });

    var sig = visible.map(function (i) { return i.key + ':' + i.quantity + ':' + i.final_price; }).join('|');
    if (sig !== state.lastItemsSig) {
      state.lastItemsSig = sig;
      var keepTop = els.scroll ? els.scroll.scrollTop : 0;
      if (visible.length === 0) {
        els.items.innerHTML = '';
        els.empty.hidden = false;
      } else {
        els.empty.hidden = true;
        els.items.innerHTML = visible.map(lineHTML).join('');
      }
      if (els.scroll) els.scroll.scrollTop = keepTop; // no saltar al reconstruir la lista
    }

    if (els.checkout) {
      var payable = visible.some(function (it) { return !isGiftRole(it); });
      if (payable) els.checkout.removeAttribute('disabled');
      else els.checkout.setAttribute('disabled', ''); // carrito vacío o solo regalos
    }

    var insuranceLine = null;
    for (var i = 0; i < cart.items.length; i++) { if (roleOf(cart.items[i]) === 'insurance') { insuranceLine = cart.items[i]; break; } }

    var savings = cart.total_discount || 0;
    cart.items.forEach(function (it) {
      if (isManaged(it)) return;
      var c = compareAtFor(it);
      if (c && c > it.original_price) savings += (c - it.original_price) * it.quantity;
    });
    if (savings > 0) {
      els.saved.textContent = (els.saved.getAttribute('data-label') || 'AHORRA') + ' ' + money(savings);
      els.saved.hidden = false;
    } else {
      els.saved.hidden = true;
    }

    els.total.textContent = money(cart.total_price);

    if (els.insuranceToggle) {
      if (!state.insuranceBusy) els.insuranceToggle.checked = !!insuranceLine;
      if (els.insurancePrice) {
        var ip = insuranceLine ? insuranceLine.final_price : (CFG.insurancePrice ? CFG.insurancePrice * 100 : 0);
        els.insurancePrice.textContent = ip ? '(' + money(ip) + ')' : '';
      }
    }

    if (els.track) {
      var inCart = {};
      cart.items.forEach(function (it) { inCart[String(it.variant_id)] = true; });
      els.track.querySelectorAll('[data-fc-upsell-add]').forEach(function (btn) {
        if (btn.classList.contains('is-adding')) return; // keep optimistic state during request
        setBtn(btn, inCart[btn.getAttribute('data-variant-id')] ? 'added' : 'available');
      });
      updateUpsellNav();
    }
  }

  function setBtn(btn, st) {
    if (btn.dataset.fcState === st) return; // idempotent — no class thrash / flicker
    btn.dataset.fcState = st;
    btn.classList.toggle('is-adding', st === 'adding');
    btn.classList.toggle('is-added', st === 'added');
    if (st === 'adding') { btn.disabled = true; btn.textContent = 'Agregando…'; }
    else if (st === 'added') { btn.disabled = true; btn.textContent = '✓ Agregado'; }
    else { btn.disabled = false; btn.textContent = 'Agregar'; }
  }
  function setUpsellState(vid, st) {
    if (!els.track) return;
    var list = els.track.querySelectorAll('[data-fc-upsell-add][data-variant-id="' + vid + '"]');
    for (var i = 0; i < list.length; i++) setBtn(list[i], st);
  }

  /* ---------- reconcile: gift + insurance. NEVER touches customer lines. ---------- */
  function customerSubtotal(cart) {
    var s = 0;
    cart.items.forEach(function (it) { if (!isManaged(it)) s += it.original_line_price; });
    return s;
  }
  function findManaged(cart, role) {
    for (var i = 0; i < cart.items.length; i++) if (roleOf(cart.items[i]) === role) return cart.items[i];
    return null;
  }

  // one atomic step; returns a promise<boolean acted>
  function reconcileStep() {
    var cart = state.cart;
    if (!cart) return Promise.resolve(false);

    var subtotal = customerSubtotal(cart);
    var hasCustomerItems = subtotal > 0;
    var eligibleForGift = hasCustomerItems && subtotal >= GIFT_MIN;

    var gift = findManaged(cart, 'gift');
    var ins = findManaged(cart, 'insurance');
    var packGift = findManaged(cart, 'pack_gift');

    // ----- REGALO DE PACK (niveles 3/4): nunca se agrega desde acá; se quita si queda solo -----
    if (packGift && !hasCustomerItems) {
      return changeLine({ id: packGift.key, quantity: 0 }).then(function () { return true; });
    }
    if (packGift && packGift.quantity !== 1) {
      return changeLine({ id: packGift.key, quantity: 1 }).then(function () { return true; });
    }

    // ----- GIFT -----
    if (CFG.giftEnabled && GIFT_ID && !state.giftGaveUp) {
      if (eligibleForGift && !gift) {
        return addLine({ id: GIFT_ID, quantity: 1, properties: mkProps('gift') }).then(function (res) {
          if (!res.ok) state.giftGaveUp = true;
          return true;
        });
      }
      if (gift && !eligibleForGift) {
        return changeLine({ id: gift.key, quantity: 0 }).then(function () { return true; });
      }
      if (gift && gift.quantity !== 1) {
        return changeLine({ id: gift.key, quantity: 1 }).then(function () { return true; });
      }
      // safety: if the automatic discount never made it free, drop it and stop trying
      if (gift && gift.final_price > 0) {
        state.giftGaveUp = true;
        return changeLine({ id: gift.key, quantity: 0 }).then(function () { return true; });
      }
    } else if (gift && (!CFG.giftEnabled || state.giftGaveUp)) {
      return changeLine({ id: gift.key, quantity: 0 }).then(function () { return true; });
    }

    // ----- INSURANCE -----
    if (CFG.insuranceEnabled && INSURANCE_ID) {
      var want = wantsInsurance() && hasCustomerItems;
      if (want && !ins) {
        return addLine({ id: INSURANCE_ID, quantity: 1, properties: mkProps('insurance') }).then(function () { return true; });
      }
      if (ins && !want) {
        return changeLine({ id: ins.key, quantity: 0 }).then(function () { return true; });
      }
      if (ins && ins.quantity !== 1) {
        return changeLine({ id: ins.key, quantity: 1 }).then(function () { return true; });
      }
    } else if (ins) {
      return changeLine({ id: ins.key, quantity: 0 }).then(function () { return true; });
    }

    return Promise.resolve(false);
  }
  function mkProps(role) { var p = {}; p[ROLE_PROP] = role; return p; }

  function reconcile(depth) {
    depth = depth || 0;
    if (state.reconciling || depth > 3) return Promise.resolve();
    state.reconciling = true;
    return reconcileStep().then(function (acted) {
      state.reconciling = false;
      if (!acted) return;
      return loadCart().then(function () { return reconcile(depth + 1); });
    }, function () { state.reconciling = false; });
  }

  /* ---------- load + refresh (debounced, coalesced) ---------- */
  function loadCart() {
    return getCart().then(function (cart) {
      state.cart = cart;
      var handles = {};
      cart.items.forEach(function (it) { if (it.handle && state.productCache[it.handle] === undefined) handles[it.handle] = 1; });
      var need = Object.keys(handles);
      if (!need.length) return cart;
      return Promise.all(need.map(getProduct)).then(function () { return cart; });
    });
  }

  var pending = null;
  var runningReconcile = false;
  function refresh(opts) {
    opts = opts || {};
    if (pending) { pending.reconcile = pending.reconcile || !!opts.reconcile; return pending.promise; }
    var box = {};
    box.reconcile = !!opts.reconcile;
    box.promise = new Promise(function (resolve) {
      setTimeout(function () {
        var doReconcile = box.reconcile;
        pending = null;
        loadCart()
          .then(function () { render(); })
          .then(function () { return doReconcile ? reconcile() : null; })
          .then(function () { render(); updateBubble(); })
          .catch(function () {})
          .then(resolve);
      }, 40);
    });
    pending = box;
    return box.promise;
  }

  /* ---------- upsell carousel ---------- */
  function cardWidth() {
    var card = els.track && els.track.querySelector('.firme-cart__upsell');
    if (!card) return 0;
    var gap = parseFloat(getComputedStyle(els.track).columnGap || '10') || 10;
    return card.getBoundingClientRect().width + gap;
  }
  function updateUpsellNav() {
    if (!els.track || !els.upsellPrev) return;
    var max = els.track.scrollWidth - els.track.clientWidth - 2;
    els.upsellPrev.disabled = els.track.scrollLeft <= 2;
    els.upsellNext.disabled = els.track.scrollLeft >= max;
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-fc-close]')) { close(); return; }

    var inc = t.closest('[data-fc-inc]');
    var dec = t.closest('[data-fc-dec]');
    var rem = t.closest('[data-fc-remove]');
    var addUp = t.closest('[data-fc-upsell-add]');

    if (inc || dec) {
      var b = inc || dec;
      var key = b.getAttribute('data-key');
      var it = state.cart && state.cart.items.filter(function (x) { return x.key === key; })[0];
      if (!it) return;
      var q = Math.max(1, it.quantity + (inc ? 1 : -1));
      b.disabled = true;
      changeLine({ id: key, quantity: q }).then(function () { return refresh({ reconcile: true }); });
      return;
    }
    if (rem) {
      rem.disabled = true;
      changeLine({ id: rem.getAttribute('data-key'), quantity: 0 }).then(function () { return refresh({ reconcile: true }); });
      return;
    }
    if (addUp && !addUp.disabled) {
      var uvid = addUp.getAttribute('data-variant-id');
      setUpsellState(uvid, 'adding'); // instant feedback, no waiting on the network
      addLine({ id: uvid, quantity: 1 })
        .then(function (res) {
          if (res && res.ok) { setUpsellState(uvid, 'added'); return refresh({ reconcile: true }); }
          setUpsellState(uvid, 'available');
        })
        .catch(function () { setUpsellState(uvid, 'available'); });
      return;
    }
    if (t.closest('[data-fc-checkout]')) {
      if (els.checkout && els.checkout.hasAttribute('disabled')) return;
      window.location.href = '/checkout';
    }
  });

  if (els.insuranceToggle) {
    els.insuranceToggle.addEventListener('change', function () {
      setInsurancePref(els.insuranceToggle.checked); // keep the toggle where the user left it
      state.insuranceBusy = true;
      refresh({ reconcile: true }).then(function () { state.insuranceBusy = false; render(); });
    });
  }
  if (els.upsellPrev) {
    els.upsellPrev.addEventListener('click', function () { els.track.scrollBy({ left: -cardWidth(), behavior: 'smooth' }); });
    els.upsellNext.addEventListener('click', function () { els.track.scrollBy({ left: cardWidth(), behavior: 'smooth' }); });
    els.track.addEventListener('scroll', updateUpsellNav, { passive: true });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });

  /* open now (compositor-only), paint from cache, sync in background */
  function openAndRefresh(reconcile) {
    open();
    if (state.cart) render();               // instant content from the warm cache
    refresh({ reconcile: !!reconcile });    // debounced network sync
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"], .header__icon--cart');
    if (!trigger || trigger.closest('#FirmeCart')) return;
    e.preventDefault();
    e.stopPropagation();
    openAndRefresh(true);
  }, true);

  /* neutralize Shrine's native drawer */
  if (window.customElements) {
    ['cart-drawer', 'cart-notification'].forEach(function (name) {
      customElements.whenDefined(name).then(function () {
        var C = customElements.get(name);
        if (C && C.prototype) {
          C.prototype.open = function () {};
          if (C.prototype.setActiveElement) C.prototype.setActiveElement = function () {};
        }
      }).catch(function () {});
    });
  }

  /* detect cart mutations from product forms / sticky ATC / apps */
  function onExternalCartChange(isAdd) {
    if (isAdd && CFG.autoOpen) {
      open();                              // drawer appears immediately
      if (state.cart) render();            // paint the cached contents right away
      getCart().then(function (c) {        // fast line-item refresh (~one /cart.js)
        state.cart = c;
        render();
      }).catch(function () {});
    }
    refresh({ reconcile: true });          // full sync (prices, gift, insurance) in the background
  }
  var CART_MUT_RE = /(\/cart\/(add|change|update|clear)(\.js)?|\/discount\/[^/?]+)/;
  var patchedFetch = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string' ? input : (input && input.url)) || '';
    var p = patchedFetch.apply(this, arguments);
    if (CART_MUT_RE.test(url) && url.indexOf('/cart.js') === -1) {
      var isAdd = /\/cart\/add/.test(url);
      p.then(function (r) { if (r && r.ok) onExternalCartChange(isAdd); }).catch(function () {});
    }
    return p;
  };
  var xopen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (typeof url === 'string' && CART_MUT_RE.test(url) && url.indexOf('/cart.js') === -1) {
      var isAdd = /\/cart\/add/.test(url);
      this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) onExternalCartChange(isAdd); });
    }
    return xopen.apply(this, arguments);
  };

  /* warm the cache so the first open is instant */
  loadCart().then(render).catch(function () {});
})();
